<highcharts-chart [style.display]="'block'" *ngIf="reportsDates.length; else placeholder" id="statisticsChart" [Highcharts]="HighStock" [options]="statisticsChartOptions">
</highcharts-chart>
<ng-template #placeholder>
  <div class="container">Selected user has not generated any report.</div>
</ng-template>
